/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextplacedescription3Inputs */

const en_aitextplacedescription3 = /** @type {(inputs: Aitextplacedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your place and let AI write the description.`)
};

const de_aitextplacedescription3 = /** @type {(inputs: Aitextplacedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibe deinen Ort und lass die KI den Beschreibungstext schreiben.`)
};

/**
* | output |
* | --- |
* | "Describe your place and let AI write the description." |
*
* @param {Aitextplacedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextplacedescription3 = /** @type {((inputs?: Aitextplacedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextplacedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextplacedescription3(inputs)
	return de_aitextplacedescription3(inputs)
});
export { aitextplacedescription3 as "aiTextPlaceDescription" }